module.exports = __webpack_public_path__ + "img/4948872415118.fe395e85.jpg";